import { ActionPermissionId, ActiveUserProfile } from '@dh-io-mhb2b/api-model';

export interface B2XEnsureProperties {
  ensureProperties?: Array<string>;
}

declare const VERSION: string;

export interface HasMeta {
  meta?: Meta;
}

export interface Meta {
  version: string;
  status: MetaState;
  actionPermissions?: Array<ActionPermissionIdWithStatus>;
}

export type ActionPermissionIdWithStatus = ActionPermissionId & {
  status: boolean;
};

export type MetaState = 'INITIALIZING' | 'READY';

export type B2XActiveProfileState = ActiveUserProfile & B2XEnsureProperties & HasMeta;
export type B2XActiveProfilePersistedState = B2XActiveProfileState;

export const initialState = () =>
  ({
    fleets: [],
    vehicles: [],
    roles: [],
    userJourneyCache: {},
    permissions: {
      actionPermissions: [],
      servicePermissions: [],
      entityPermissions: [],
    },
    ensureProperties: [],
    meta: {
      version: VERSION,
      status: 'INITIALIZING',
      // temporary object to manage permissions till we align with other teams for a global change on current state of permissions
      actionPermissions: [],
    },
  }) as B2XActiveProfileState;
